//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { date } from "quasar";
import { mapActions, mapState } from "vuex";
import router from "../../router";
// import { parse } from "vue-currency-input";
import purchaseOrderItems from "./components/PurchaseOrderItems";
import dimensions from "./components/Dimensions";
import { parse } from "vue-currency-input";

export default {
  data() {
    return {
      pagination: {
        rowsPerPage: 30, // current rows per page being displayed
      },
      orderStatus: "",
      orderNumber: "",

      customers: [],
      Currencies: [],
      orderExchangeRate: {},
      clst1: "primary",
      clst2: "gray",
      clst3: "gray",
      clst4: "gray",
      clst5: "gray",
      txtcl1: "white",
      txtcl2: "black",
      txtcl3: "black",
      txtcl4: "black",
      txtcl5: "black",
      totalText: "Totalt",
      quantityText: "Antall",
      totalValue: "0",
      totalValueNative: "0",
      orderitemsQuantity: 0,

      VatTypes: [],

      FilterVatTypes: [],
      Suppliers: [],
      FilterSuppliers: [],
      supplierName: "",
      SupplierEmails: [],
      FilterSupplierEmails: [],
      order: {},
      headerTitle: "",

      tab: "details",
      tabSupplier: "supplierTab",
      id: 0,

      rowCount: 10,
      existingOrder: false,
      dense: true,
    };
  },

  components: {
    purchaseOrderItems,
    dimensions,
  },

  computed: {
    ...mapState("main", ["currencies", "suppliers"]),
    currencyOptions() {
      return {
        currency: null,
        locale: "no-NO",
      };
    },
  },

  methods: {
    async refresh() {
      const notif = this.$q.notify({
        type: "ongoing",
        message: "Laster data...",
      });

      this.id = this.$route.params.id;
      if (this.id > 0) {
        await this.fetchPurchase(this.id);
        this.existingOrder = true;
      }

      setTimeout(() => {
        notif();
      }, 500);
    },
    setModel(val) {
      console.log("email");
      console.log(val);
      this.order.supplierEmail = val;
    },

    getEmailFromSupplierFilter(val, update) {
      console.log(this.FilterSupplierEmails);
      if (!this.SupplierEmails) {
        update();
        return;
      }
      update(() => {
        this.SupplierEmails = this.FilterSupplierEmails.filter(
          (w) => w.toLowerCase().indexOf(val.toLowerCase()) > -1
        );
      });
    },

    getSupplierFilter(val, update) {
      console.log("getSupplierFilter", this.Suppliers);
      if (!this.Suppliers) {
        update();
        return;
      }
      update(() => {
        this.Suppliers = this.FilterSuppliers.filter(
          (w) =>
            w.name.toLowerCase().indexOf(val.toLowerCase()) > -1 ||
            w.supplierNumber
              .toString()
              .toLowerCase()
              .indexOf(val.toLowerCase()) > -1
        );

        console.log("getWarehouseFilter update", this.Warehouses);
      });
    },

    async updateSumary() {
      console.log("starte oppdatering av sum felt nede");
      const currency = this.Currencies.find(
        (x) => x.id === this.order.currencyCodeId
      );
      this.totalText =
        this.$t("purchaseOrder.total") + " (" + currency.code + ")";
      var totValue = parseFloat(0);
      this.orderitemsQuantity = 0;
      this.order.orderItems.forEach((element) => {
        if (element.productId) {
          var price = 0;

          if (typeof element.price === "string") {
            price = parse(element.price, this.currencyOptions);
          } else {
            price = element.price;
          }
          const qtySum = element.numberOfItems * price;
          const dicsount = (qtySum * element.discountPercentage) / 100;
          totValue += qtySum - dicsount;
          this.orderitemsQuantity += element.numberOfItems;
        }
      });
      // Oppdater valuta sum
      this.totalValue = new Intl.NumberFormat("no-NO", {
        minimumFractionDigits: 2,
      }).format(totValue);

      // Oppdater sum i lokal valuta
      if (this.orderExchangeRate.id != this.order.currencyCodeId) {
        this.orderExchangeRate = await this.getExchangeRate(
          this.order.currencyCodeId
        );
      }
      if (this.orderExchangeRate)
        console.log(
          "this.orderExchangeRate: " +
            this.orderExchangeRate +
            " exchangeRate=" +
            this.orderExchangeRate.exchangeRate +
            " factor=" +
            this.orderExchangeRate.factor
        );
      if (this.orderExchangeRate.exchangeRate) {
        if (
          this.orderExchangeRate.exchangeRate != 1 &&
          this.orderExchangeRate.exchangeRate != 0
        ) {
          totValue = totValue * this.orderExchangeRate.exchangeRate;
        }
        this.totalValueNative = new Intl.NumberFormat("no-NO", {
          minimumFractionDigits: 2,
        }).format(Math.round(totValue * 100) / 100);
      } else {
        this.totalValueNative = "";
      }
    },

    setStatusColors(status) {
      console.log("status");
      console.log(status);
      if (status == 100) {
        (this.clst1 = "primary"),
          (this.clst2 = "gray"),
          (this.clst3 = "gray"),
          (this.clst4 = "gray"),
          (this.clst5 = "gray"),
          (this.txtcl1 = "white"),
          (this.txtcl2 = "black"),
          (this.txtcl3 = "black"),
          (this.txtcl4 = "black"),
          (this.txtcl5 = "black");
      } else if (status == 200) {
        (this.clst1 = "green"),
          (this.clst2 = "primary"),
          (this.clst3 = "gray"),
          (this.clst4 = "gray"),
          (this.clst5 = "gray"),
          (this.txtcl1 = "black"),
          (this.txtcl2 = "white"),
          (this.txtcl3 = "black"),
          (this.txtcl4 = "black"),
          (this.txtcl5 = "black");
      } else if (status == 300) {
        (this.clst1 = "green"),
          (this.clst2 = "green"),
          (this.clst3 = "primary"),
          (this.clst4 = "gray"),
          (this.clst5 = "gray"),
          (this.txtcl1 = "black"),
          (this.txtcl2 = "black"),
          (this.txtcl3 = "white"),
          (this.txtcl4 = "black"),
          (this.txtcl5 = "black");
      } else if (status == 400) {
        (this.clst1 = "green"),
          (this.clst2 = "green"),
          (this.clst3 = "green"),
          (this.clst4 = "primary"),
          (this.clst5 = "gray"),
          (this.txtcl1 = "black"),
          (this.txtcl2 = "black"),
          (this.txtcl3 = "black"),
          (this.txtcl4 = "white"),
          (this.txtcl5 = "black");
      } else if (status == 500) {
        (this.clst1 = "green"),
          (this.clst2 = "green"),
          (this.clst3 = "green"),
          (this.clst4 = "green"),
          (this.clst5 = "primary"),
          (this.txtcl1 = "black"),
          (this.txtcl2 = "black"),
          (this.txtcl3 = "black"),
          (this.txtcl4 = "black"),
          (this.txtcl5 = "white");
      }
    },

    supplierValueChanged(value) {
      console.log(value);
      //TODO endre email filter
      console.log(this.Suppliers);
      this.SupplierEmails = this.Suppliers.find((x) => x.id == value).emails;
      this.FilterSupplierEmails = this.Suppliers.find(
        (x) => x.id == value
      ).emails;
      this.supplierName = this.Suppliers.find((x) => x.id == value).name;
      // console.log(emails);
      // emails.forEach((element) => {
      //   console.log(element);
      // });
    },

    newPurchase() {
      this.setStatusColors(100);
      this.order.suppliersOrderNo = null;
      this.headerTitle = "Innkjøpsordre";
      this.order = {
        suppliersOrderNo: "",
        purchaseOrderStatusId: 100,
        currencyCodeId: 1,
        localization: "no",
        tax: "",
        label: "",
        yourReference: "",
        ourReference: "",
        deliveryTerms: "",
        deliveryMethod: "",
        receiver: "",
        shippingAddressLine1: "",
        shippingAddressLine2: "",
        shippingPostalCode: "",
        shippingCountry: "",
        comment: "",
        orderDate: date.formatDate(Date.now(), "DD-MM-YYYY"),
        orderItems: [],
      };
    },
    async delPurchaseOrder() {
      if (this.order.purchaseOrderStatusId < 400) {
        try {
          await this.deletePurchaseOrder(this.id);
          this.$notify({
            group: "foo",
            title: "",
            text: this.$t("common.deleteMessage"),
          });
          router.push({
            name: "Purchases",
          });
        } catch (error) {
          console.log("error", error);
          this.$notify({
            group: "foo",
            title: this.$t("common.errorSave"),
            text: error,
            type: "error",
          });
        }
      } else {
        this.$notify({
          group: "foo",
          title: this.$t("common.errorSave"),
          text: this.$t("purchaseOrder.deleteDenied"),
          type: "error",
        });
      }
    },

    async createDraft() {
      if (!this.order.supplierId) {
        this.$notify({
          group: "foo",
          title: "",
          text: this.$t("purchaseOrder.messageMissingSupplier"),
          type: "error",
        });
        return;
      }

      var items = await this.getSuggestedOrderItemsBySupplier(
        this.order.supplierId
      );

      this.order.orderItems = items;
      console.log(items);

      this.updateSumary();
    },
    calculateSum() {
      if (this.order.orderItems) {
        this.order.orderItems.forEach((element) => {
          if (element.productId) {
            var price = 0;
            if (typeof element.price === "string") {
              price = parse(element.price, this.currencyOptions);
            } else {
              price = element.price;
            }
            const qtySum = element.numberOfItems * price;

            const vat = this.VatTypes.find((k) => k.id === element.vatTypeId);
            console.log(vat);
            const dicsount = (qtySum * element.discountPercentage) / 100;
            const total = qtySum - dicsount;
            element.sum = new Intl.NumberFormat("no-NO").format(total);
          }
        });
      }
    },

    async purchaseOrderPdf(orderId) {
      const notif = this.$q.notify({
        message: this.$t("common.downloading"),
        timeout: 0,
        spinner: true,
      });

      this.getPurchaseOrderReport(orderId).then((res) => {
        notif();
        const url = window.URL.createObjectURL(new Blob([res]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "PurchaseOrder.pdf");
        document.body.appendChild(link);
        link.click();
      });
    },

    async save() {
      try {
        var lines = [];
        if (this.id == 0) {
          if (!this.order.supplierId) {
            console.log(this.order.supplierId);
            this.$notify({
              group: "foo",
              title: "",
              text: this.$t("purchaseOrder.messageMissingSupplier"),
              type: "error",
            });
            return;
          }
          console.log("Oppretter ny ordre");
          var postOrder = {};

          postOrder.purchaseOrderStatusId = this.order.purchaseOrderStatusId;
          postOrder.currencyCodeId = this.order.currencyCodeId;
          postOrder.supplierId = this.order.supplierId;
          postOrder.supplierName = this.supplierName;
          postOrder.supplierEmail = this.order.supplierEmail;
          postOrder.localization = this.order.localization;
          if (this.order.orderDate) {
            var parts = this.order.orderDate.split("-");
            postOrder.orderDate = new Date(parts[2], parts[1] - 1, parts[0]);
          }
          if (this.order.invoiceDate) {
            var iparts = this.order.invoiceDate.split("-");
            postOrder.invoiceDate = new Date(
              iparts[2],
              iparts[1] - 1,
              iparts[0]
            );
          }

          if (this.order.deliveryDate) {
            var dparts = this.order.deliveryDate.split("-");
            postOrder.deliveryDate = new Date(
              dparts[2],
              dparts[1] - 1,
              dparts[0]
            );
          }

          postOrder.invoiceNumber = this.order.invoiceNumber;
          postOrder.supplierOrderNumber = this.order.supplierOrderNumber;
          postOrder.comment = this.order.comment;
          postOrder.deliveryAddressLine1 = this.order.deliveryAddressLine1;
          postOrder.deliveryAddressLine2 = this.order.deliveryAddressLine2;
          postOrder.deliveryAddressLine3 = this.order.deliveryAddressLine3;
          postOrder.deliveryCity = this.order.deliveryCity;
          postOrder.deliveryCountry = this.order.deliveryCountry;
          postOrder.deliveryCountryCode = this.order.deliveryCountryCode;
          postOrder.deliveryPostalCode = this.order.deliveryPostalCode;
          postOrder.deliveryName = this.order.deliveryName;
          postOrder.yourReference = this.order.yourReference;
          postOrder.ourReference = this.order.ourReference;
          postOrder.label = this.order.label;
          postOrder.purchaser = this.order.purchaser;
          this.order.orderItems.forEach((element) => {
            var line = {};
            line["productId"] = element.productId;
            line["itemText"] = element.itemText;
            line["numberOfItems"] = element.numberOfItems;
            line["discountPercentage"] = element.discountPercentage;
            if (typeof element.price === "string") {
              line["price"] = parse(element.price, this.currencyOptions);
            } else {
              line["price"] = element.price;
            }

            line["dimension1Id"] = element.dimension1Id;
            line["dimension2Id"] = element.dimension2Id;
            line["dimension3Id"] = element.dimension3Id;
            line["dimension4Id"] = element.dimension4Id;
            line["dimension5Id"] = element.dimension5Id;
            line["dimension6Id"] = element.dimension6Id;
            line["dimension7Id"] = element.dimension7Id;
            line["dimension8Id"] = element.dimension8Id;
            line["dimension9Id"] = element.dimension9Id;

            if (element.deliveryDate) {
              var dlparts = element.deliveryDate.split("-");
              line["deliveryDate"] = new Date(
                dlparts[2],
                dlparts[1] - 1,
                dlparts[0]
              );
            }
            lines.push(line);
          });
          postOrder.orderItems = lines;
          console.log(postOrder);
          var createdDto = await this.postPurchaseOrder(postOrder);
          this.internalID = createdDto.id;
          this.mapOrder(createdDto);
        } else {
          console.log("Endrer på ordre");
          var putOrder = {};
          putOrder.purchaseOrderStatusId = this.order.purchaseOrderStatusId;
          putOrder.currencyCodeId = this.order.currencyCodeId;
          putOrder.supplierId = this.order.supplierId;
          putOrder.supplierName = this.supplierName;
          putOrder.supplierEmail = this.order.supplierEmail;
          putOrder.localization = this.order.localization;

          var tempDate;
          if (this.order.orderDate) {
            tempDate = this.order.orderDate.split("-");
            putOrder.orderDate = new Date(
              tempDate[2],
              tempDate[1] - 1,
              tempDate[0]
            );
          }
          if (this.order.invoiceDate) {
            tempDate = this.order.invoiceDate.split("-");
            putOrder.invoiceDate = new Date(
              tempDate[2],
              tempDate[1] - 1,
              tempDate[0]
            );
          }

          if (this.order.deliveryDate) {
            tempDate = this.order.deliveryDate.split("-");
            putOrder.deliveryDate = new Date(
              tempDate[2],
              tempDate[1] - 1,
              tempDate[0]
            );
          }

          putOrder.invoiceDate = this.order.invoiceDate;
          putOrder.invoiceNumber = this.order.invoiceNumber;
          putOrder.supplierOrderNumber = this.order.supplierOrderNumber;
          putOrder.comment = this.order.comment;
          putOrder.dimension1Id = this.order.dimension1Id;
          putOrder.dimension2Id = this.order.dimension2Id;
          putOrder.dimension3Id = this.order.dimension3Id;
          putOrder.dimension4Id = this.order.dimension4Id;
          putOrder.dimension5Id = this.order.dimension5Id;
          putOrder.dimension6Id = this.order.dimension6Id;
          putOrder.dimension7Id = this.order.dimension7Id;
          putOrder.dimension8Id = this.order.dimension8Id;
          putOrder.dimension9Id = this.order.dimension9Id;
          putOrder.deliveryAddressLine1 = this.order.deliveryAddressLine1;
          putOrder.deliveryAddressLine2 = this.order.deliveryAddressLine2;
          putOrder.deliveryAddressLine3 = this.order.deliveryAddressLine3;
          putOrder.deliveryCity = this.order.deliveryCity;
          putOrder.deliveryCountry = this.order.deliveryCountry;
          putOrder.deliveryCountryCode = this.order.deliveryCountryCode;
          putOrder.deliveryPostalCode = this.order.deliveryPostalCode;
          putOrder.deliveryName = this.order.deliveryName;
          putOrder.yourReference = this.order.yourReference;
          putOrder.ourReference = this.order.ourReference;
          putOrder.label = this.order.label;
          putOrder.purchaser = this.order.purchaser;
          this.order.orderItems.forEach((element) => {
            var line = {};
            line["id"] = element.id;
            line["purchaseOrderId"] = element.purchaseOrderId;
            line["productId"] = element.productId;
            line["itemText"] = element.itemText;
            line["numberOfItems"] = element.numberOfItems;

            if (typeof element.price === "string") {
              line["price"] = parse(element.price, this.currencyOptions);
            } else {
              line["price"] = element.price;
            }
            line["discountPercentage"] = element.discountPercentage;
            line["dimension1Id"] = element.dimension1Id;
            line["dimension2Id"] = element.dimension2Id;
            line["dimension3Id"] = element.dimension3Id;
            line["dimension4Id"] = element.dimension4Id;
            line["dimension5Id"] = element.dimension5Id;
            line["dimension6Id"] = element.dimension6Id;
            line["dimension7Id"] = element.dimension7Id;
            line["dimension8Id"] = element.dimension8Id;
            line["dimension9Id"] = element.dimension9Id;

            if (element.deliveryDate) {
              var dlparts = element.deliveryDate.split("-");
              console.log(dlparts);
              line["deliveryDate"] = new Date(
                dlparts[2],
                dlparts[1] - 1,
                dlparts[0]
              );
              console.log(line["deliveryDate"]);
            }
            lines.push(line);
          });

          putOrder.orderItems = lines;
          console.log(putOrder);
          var updatedDto = await this.putPurchaseOrder({
            id: this.id,
            purchaseDto: putOrder,
          });
          this.$notify({
            group: "foo",
            title: "",
            text: this.$t("common.saveOk"),
          });
          this.mapOrder(updatedDto);
        }
      } catch (error) {
        console.log("error", error);
        this.$notify({
          group: "foo",
          title: this.$t("common.errorSave"),
          text: error,
          type: "error",
        });
      }
    },
    async fetchPurchase(id) {
      const data = await this.getPurchaseOrder(id);
      console.log(data);

      this.mapOrder(data);
    },

    async mapOrder(data) {
      console.log(data);
      this.order = data;
      this.orderNumber = this.order.id.toString();
      this.orderStatus = this.$t(
        "purchaseOrder.status-" + this.order.purchaseOrderStatusId
      );

      this.headerTitle =
        this.$t("headers.purchaseOrder") +
        " " +
        this.orderNumber +
        " - " +
        this.orderStatus;
      console.log(this.order.purchaseOrderStatusId);
      this.setStatusColors(this.order.purchaseOrderStatusId);
      this.orderExchangeRate = await this.getExchangeRate(
        this.order.currencyCodeId
      );
      this.order.orderDate = date.formatDate(data.orderDate, "DD-MM-YYYY");
      this.order.deliveryDate = date.formatDate(
        data.deliveryDate,
        "DD-MM-YYYY"
      );
      console.log("deldato");
      console.log(this.order.deliveryDate);
      console.log(data.deliveryDate);
      this.order.orderItems.forEach((element) => {
        element.deliveryDate = date.formatDate(
          element.deliveryDate,
          "DD-MM-YYYY"
        );
        console.log("levdato linje");
        console.log(element.deliveryDate);

        element.dirty = 0;
      });
      if (this.order.supplierId) {
        this.supplierValueChanged(this.order.supplierId);
      }
      this.calculateSum();
      this.updateSumary();
    },
    ...mapActions("main", [
      "getPurchaseOrder",
      "putPurchaseOrder",
      "postPurchaseOrder",
      "deletePurchaseOrder",
      "getSuggestedOrderItemsBySupplier",
      "getExchangeRate",
      "getPurchaseOrderReport",
    ]),
  },
  created() {
    // GET request using fetch with error handling
    this.id = this.$route.params.id;

    this.Currencies = this.currencies;
    this.Suppliers = this.suppliers;
    this.FilterSuppliers = this.suppliers;
    console.log(this.Suppliers + "sup");

    if (this.id > 0) {
      this.fetchPurchase(this.id);
      this.existingOrder = true;
    } else {
      console.log("nytt innkjøp");
      this.newPurchase();
    }
  },
};
